import { useSelector } from 'react-redux';

import { getIsQuoteItemLocked } from 'modules/quotePartViewer/data/reducer';
import {
  getIsInAFinalizedQuote,
  getIsInATrashedQuote,
  getIsModifiable,
} from 'modules/viewerPage/data/reducer';

const getDisabledReason = ({
  isModifiable,
  isInAFinalizedQuote,
  isInATrashedQuote,
  isQuoteItemLocked,
}: {
  isModifiable: boolean | undefined;
  isInAFinalizedQuote: boolean | undefined;
  isInATrashedQuote: boolean | undefined;
  isQuoteItemLocked: boolean;
}): string | undefined => {
  if (!isModifiable) {
    return 'Cannot edit a part associated with multiple quotes.';
  }
  if (isInAFinalizedQuote) {
    return 'Cannot edit a part associated with a finalized quote.';
  }
  if (isInATrashedQuote) {
    return 'Cannot edit a part associated with a trashed quote.';
  }
  if (isQuoteItemLocked) {
    return 'Cannot edit a part while someone else is editing it.';
  }
  return undefined;
};

export const useCanEditPartInQuote = () => {
  const isInAFinalizedQuote = useSelector(getIsInAFinalizedQuote);
  const isInATrashedQuote = useSelector(getIsInATrashedQuote);
  const isModifiable = useSelector(getIsModifiable);
  const isQuoteItemLocked = useSelector(getIsQuoteItemLocked);

  const canEdit = Boolean(
    !isQuoteItemLocked &&
      isModifiable &&
      !isInAFinalizedQuote &&
      !isInATrashedQuote,
  );

  const disabledReason = canEdit
    ? undefined
    : getDisabledReason({
        isModifiable,
        isInAFinalizedQuote,
        isInATrashedQuote,
        isQuoteItemLocked,
      });

  return { canEdit, disabledReason };
};
